"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHookForm = require("react-hook-form");

var _material = require("@mui/material");

var _messaging = require("../../../constants/messaging.types");

var styles = {
  description: {
    color: 'grey.main',
    marginLeft: 3.5,
    maxWidth: 615
  }
};

var CaptureAction = function CaptureAction(_ref) {
  var control = _ref.control,
      label = _ref.label,
      name = _ref.name,
      description = _ref.description;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    control: control,
    name: "".concat(_messaging.MessagingDataFields.RecipientActions, ".").concat(name),
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
          value = _ref2$field.value,
          _onChange = _ref2$field.onChange;
      return /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
        checked: value,
        onChange: function onChange(_, checked) {
          return _onChange(checked);
        },
        control: /*#__PURE__*/_react.default.createElement(_material.Checkbox, {
          color: "primary"
        }),
        label: label
      });
    }
  }), description && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2",
    sx: styles.description
  }, description));
};

var _default = CaptureAction;
exports.default = _default;